import React from "react";
import {FAIcon} from "./faIcon.js";
import {AppBaseProps} from "./commonApp.js";
import {Helper} from "../util/helper.js";

export default class DynamicIFrame extends React.Component<DynamicIFrameProps, DynamicIFrameState>{
    private urlBuild: boolean = false;
    constructor(props: DynamicIFrameProps) {
        super(props);
        this.state = {
            url: "",
        }
    }
    private buildUrl(props: DynamicIFrameProps) {
        if(Helper.hasValue(props.url)) {
            let url = props.url;
            url = Helper.processTemplate(url, (matches) => {
                let match = props.urlVariables?.filter(v => v.key == matches);
                if (match && match.length > 0) {
                    return getValueNoObject(match[0].value);
                } else {
                    return "";
                }
            });
            let parameters = props.urlParameters;
            if(parameters) {
                const propertyNames = Object.keys(parameters);
                if (!Helper.hasValue(props.parametersType) || props.parametersType == "query") {
                    url = getUrl(url, parameters, propertyNames, "?", "&", "=", getValue);
                } else if (props.parametersType == "path") {
                    url = getUrl(url, parameters, propertyNames, "/", "/", "/", getValueNoObject);
                }
                this.urlBuild = true;
                return decodeURIComponent(url);
            }
            this.urlBuild = true;
            return decodeURIComponent(url);
        }
        else {
            this.urlBuild = true;
            return "";
        }
        
        function getValue(param: any) {
            let stringify: string;
            if(!Helper.hasValue(param)){
                stringify = "";
            }
            else if (typeof param == "string") {
                stringify = param;
            } else {
                stringify = JSON.stringify(param);
            }
            return Helper.processTemplate(stringify, (matches) => {
                let valueByPathString = Helper.getValueByPathString(props, matches);
                if(!Helper.hasValue(valueByPathString)){
                    valueByPathString = "";
                }
                else if(typeof valueByPathString == "object"){
                    valueByPathString = JSON.stringify(valueByPathString);
                }
                else if(valueByPathString == "null" || valueByPathString == "undefined"){
                    valueByPathString = "";
                }
                return valueByPathString;
            });
        }
        
        function getValueNoObject(param: any){
            let input = param;
            if(typeof input === "object") {
                input = "";
            }
            let value = getValue(input)
            if(typeof value === "object") {
                value = "";
            }
            return value;
        }
        
        function getUrl(url: string,parameters: any[],propertyNames: string[],firstSeparator: string,paramSeparator: string, paramValueSeparator: string, getValueFunc: (input: any) => string) {
            if (!url.endsWith(firstSeparator)) {
                url += firstSeparator;
            }
            for (let propertyName of propertyNames) {
                let input = parameters[propertyName];
                let value = getValueFunc(input);
                url += `${propertyName}${paramValueSeparator}${value}${paramSeparator}`;
            }
            if (url.endsWith(paramSeparator)) {
                url = url.substring(0, url.length - 1);
            }
            return url
        }
    }
    
    componentDidMount = () => {
        this.setState({url: this.buildUrl(this.props)});
    }
    
    componentDidUpdate = (prevProps, _) => {
        if(this.urlBuild && prevProps !== this.props) {
            this.setState({url: this.buildUrl(prevProps)});
        }
    }
    render(){
        if(Helper.hasValue(this.state.url) && this.state.url !== "" && this.urlBuild){
            return <iframe key={this.state.url} src={this.state.url} style={{height: Helper.hasValue(this.props.height) ? this.props.height : '99.787%', width: Helper.hasValue(this.props.width) ? this.props.width : '100%'}}></iframe>
        }else if(this.urlBuild){
            return <div style={{ height: Helper.hasValue(this.props.height) ? this.props.height : '100%', width: Helper.hasValue(this.props.width) ? this.props.width : '100%', display: "flex", justifyContent: "center", alignItems: "center" }}>
                <div style={{ width: "fit-content", height: "fit-content"}}>
                    <FAIcon name="empty-set" prefix={"fas"} spins={false} attributes={["spin", "7x"]} style={{ color: "#767676", display: "flex", justifyContent: "center", marginBottom: "5px" }} />
                    <p>{Helper.getTranslation("Standard.CannotLoadDynamicIFrame")}</p>
                </div>
            </div>;
        }
        return <div style={{ height: Helper.hasValue(this.props.height) ? this.props.height : '100%', width: Helper.hasValue(this.props.width) ? this.props.width : '100%', display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div style={{ width: "fit-content", height: "fit-content" }}>
                <FAIcon name="spinner" prefix={"fas"} spins={true} attributes={["spin", "3x"]} style={{ color: "#767676" }} />
            </div>
        </div>;
    }
}
export interface DynamicIFrameProps extends AppBaseProps{
    parametersType?: string;
    urlParameters: any;
    urlVariables: {key: string, value: string}[];
    url: string;
    height?:string;
    width?:string;
}
export interface DynamicIFrameState{
    url: string;
}